// extracted by mini-css-extract-plugin
export var quillEditor = "_k0-1";
export var variable = "_k0-0";